// extracted by mini-css-extract-plugin
module.exports = {"icon":"Radio_icon__nulO6","label":"Radio_label__Y5vGK","radio":"Radio_radio__v7oOx"};